import get from 'lodash/get'

function derivedWord(radical, prefix = '', suffix = '') {
  return `${prefix}${radical}${suffix}`
}

export function createFormatter(rules, separator = ' ') {
  return (json) =>
    rules
      .reduce((acc, { prefix, suffix, getValue }) => {
        const jsonValue = getValue(json)

        if (jsonValue) {
          acc.push(derivedWord(jsonValue, prefix, suffix))
        }

        return acc
      }, [])
      .join(separator)
}

export function ruleAdapter({ prefix, suffix, attribute: path }) {
  return {
    prefix,
    suffix,
    getValue: (obj) => get(obj, path),
  }
}

export function isLinkValid(link, router) {
  const resolvedLink = link ? router.resolve({ ...link }).resolved : {}
  const failedResolutionPath = '/'

  return resolvedLink?.path !== failedResolutionPath
}

export function createAttributesOld(attributesRules = [], item = {}) {
  return attributesRules.map(({ label, attributes: rules }) => {
    const formatAttribute = createFormatter(
      rules.map((rule) => ruleAdapter(rule)),
    )

    return {
      label,
      attributes: formatAttribute(item),
    }
  })
}

export function createTitle(item, rules = []) {
  const formatTitle = createFormatter(rules.map((rule) => ruleAdapter(rule)))

  return formatTitle(item)
}

/** @deprecated Use createAttributes instead */
export const buildResultsFromAttributes = ({
  attributes: items = [],
  structure = {},
} = {}) => {
  const { title: titleRules = [], table: attributesRules = [] } = structure

  return items.map((item) => ({
    ...item,
    attributes: createAttributesOld(attributesRules, item),
    thumbName: createTitle(item, titleRules),
  }))
}
